<template>
  <div class="popup-container" v-if="show">
    <div class="masking" ></div>
    <div class="modal">
      <div class="header">
        <span>支付结果确认</span>
        <img :src="require('@/assets/images/icon_xx3.png')" alt="" class="icon-close" @click="show=!show">
      </div>
      <div class="info">
        <p class="p1">付款完成前请不要关闭此窗口。</p>
        <p class="p2">付款完成前请不要关闭此窗口。</p>
        <p class="p3">付款完成前请不要关闭此窗口。</p>
        <p class="p4">付款完成前请不要关闭此窗口。</p>
      </div>
      <div class="btn-container">
        <span class="span1">支付成功</span>
        <span class="span2">重新支付</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      show:false
    }
  }
}
</script>
<style lang="scss" scoped>
  .modal{
    width: 550px;
    padding:20px 30px;
    .header{
      margin-bottom: 26px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
      span{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
      }
    }
    .info{
      p{
        font-size: 14px;
        color: #505050;
      }
      .p1{
        margin-bottom: 22px;
      }
      .p2{
        margin-bottom: 20px;
      }
      .p3{
        margin-bottom: 20px;
      }
      .p4{
        margin-bottom: 36px;
      }
    }
    .btn-container{
      display: flex;
      justify-content: center;
      margin-bottom: 30px;
      span{
        cursor: pointer;
        width: 134px;
        height: 44px;
        border-radius: 2px;
        font-size: 16px;
        line-height: 44px;
        text-align: center;
      }
      .span1{
        background: #fa4b4b;
        color: #ffffff;
        margin-right: 40px;
      }
      .span2{
        border:1px solid  #fa4b4b;
        color: #fa4b4b;
      }
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/pages/cart/components/cart-pay-popup.vue